module.exports = __webpack_public_path__ + "img/icon04.fd28a14d.png";